import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { RecipientType } from '@40seas/entities/notifications';
import { z } from 'zod';
import { NotificationDeliveryMethod } from '../notification-delivery-method.enum';

export const BusinessContactsRecipientsProviderPayloadSchema = z.object({
    isPrimary: z.boolean(),
    method: EnumSchema(NotificationDeliveryMethod).optional(),
    type: EnumSchema(RecipientType),
});

export class BusinessContactsRecipientsProviderPayload extends FromSchema(BusinessContactsRecipientsProviderPayloadSchema) {
    isPrimary: boolean; // true/false for business contacts filter
    method?: NotificationDeliveryMethod;
    type: RecipientType; // Primary/Secondary for output recipent types
}
